import styles from './About.module.css';

export default function About() {
  return (
    <div className={styles.container}>
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h1 className={styles.title}>About MyPeopleDatabase</h1>
        <p className={styles.description}>
          MyPeopleDatabase is a modern solution for managing and organizing people data. Built with
          the latest technologies, it provides a secure and efficient way to handle your contacts
          and relationships.
        </p>

        <div className={styles.tilesContainer}>
          <div className={styles.tile}>
            <h2 className={styles.tileTitle}>Contact Us</h2>
            <div className={styles.tileContent}>
              <p className={styles.emailLabel}>Email:</p>
              <a href="mailto:support@mypeopledatabase.com" className={styles.emailLink}>
                support@mypeopledatabase.com
              </a>
            </div>
          </div>

          <div className={styles.tile}>
            <h2 className={styles.tileTitle}>Our Philosophy</h2>
            <div className={styles.tileContent}>
              <p>
                We believe your relationships are yours to own. In an era where connections are
                often commoditized by platforms, MyPeopleDatabase stands for true data
                ownership—putting you in complete control of your relationships data and how it's
                used.
              </p>
            </div>
          </div>

          <div className={styles.tile}>
            <h2 className={styles.tileTitle}>About the Company</h2>
            <div className={styles.tileContent}>
              <p>
                Created by Object Nirvana, Inc. We offer consulting services and custom software
                solutions such as what you see on this site.
              </p>
            </div>
          </div>

          <div className={styles.tile}>
            <h2 className={styles.tileTitle}>Safety & Security</h2>
            <div className={styles.tileContent}>
              <p>
                Your data security and privacy are our top priorities. Learn about our local-first
                architecture, encryption, and commitment to keeping your data safe.
              </p>
              <a href="/safety" className={styles.safetyLink}>
                Learn why MyPeopleDatabase is safe to use →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
